export default __webpack_public_path__ + "static/media/49.41154bc6.jpg";